import db from '../../versa/db.js';

// Requires observer.js
export default function (...args)
{
	return {
		async actions(ev, publisher, lot_id)
		{
			let company_id = this.locate('company_id').getValue();
			if (!company_id || company_id < 0 || !lot_id || lot_id < 0)
				return;
			let lot = await db.get('lots', [company_id, Number(lot_id)], 1);
			if (!lot)
				return;
			if (this.isEmpty())
			{
				this.setValue(lot.lot_number);
				this.refresh();
			}
			let product = await db.get('products', [company_id, lot.product_id]);
			if (!product)
				return;
			let sku = this.locate(this.makeId('sku-0'));
			if (sku.isEmpty())
			{
				sku.setValue(product.sku.join(''));
				sku.refresh();
			}
		}
	};
}

